(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceAddOnCustom', ServiceAddOnCustom);

    ServiceAddOnCustom.$inject = ['$resource'];

    function ServiceAddOnCustom($resource) {


        var getAllCompanyServiceAddOns = function () {

            var resourceUrl = 'api/get-all-company-service-add-ons';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var getActiveServiceAddOns = function () {

            var resourceUrl = 'api/active-service-add-ons-by-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var deleteServiceAddOns = function (id) {

            var resourceUrl = 'api/service-add-ons/'+id;
            return $resource(resourceUrl, {}, {
                    'delete': {method: 'delete', isArray: true}
                }
            );
        };


        return {
            getAllCompanyServiceAddOns: getAllCompanyServiceAddOns,
            getActiveServiceAddOns: getActiveServiceAddOns,
            deleteServiceAddOns: deleteServiceAddOns
        };
    }
})();
